import { isInArray } from "../../../core/util/is-in-array";
import { Membership } from "../membership/membership.model";
import { User } from "../user/user.model";
import { IAclFilterCustomCheck } from "../../store/queries/acl-filter-custom-check.interface";
import { Task } from "./task.model";

export class TaskAclFilterCategoryCheck implements IAclFilterCustomCheck<Task> {

    constructor(protected itemProperty: string = "taskType", protected membershipProperty: string = "taskTypes") {

    }

    hasAccess(item: Task, membership: Membership, user: User): boolean {
        return isInArray(item[this.itemProperty], membership[this.membershipProperty]);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/task/task.acl-filter.ts